import {Formatter} from './units-formatter';

export class IntegrationToDaysFormatter extends Formatter {
  apply(seconds: number): string {
    seconds = seconds / (24 * 60 * 60);
    return seconds.toFixed(this.numberDecimals);
  }
}

export class IntegrationToHoursFormatter extends Formatter {
  apply(seconds: number): string {
    seconds = seconds / (60 * 60);
    return seconds.toFixed(this.numberDecimals);
  }
}

export class IntegrationToMinutesFormatter extends Formatter {
  apply(seconds: number): string {
    seconds = seconds / 60;
    return seconds.toFixed(this.numberDecimals);
  }
}
